import Payments from './payment.vue';
import { acceptProps, compose } from 'vue-compose';
import { withCurrentUser } from '@/shared/authentication';
export default compose(withCurrentUser, acceptProps('pledgeId'))(Payments);
